module.exports = __webpack_public_path__ + "img/section7-img.26ef166e.jpg";